export const DICE_COUNT = 6;
/** Lanci totali per mano: 1 iniziale + 2 rilanci liberi. Il rilancio forzato TILT arriva in Sprint 1. */
export const MAX_ROLLS = 3;

export type ComboId =
  | 'pair'
  | 'two-pair'
  | 'three-kind'
  | 'full-house'
  | 'small-straight'
  | 'large-straight'
  | 'four-kind'
  | 'five-kind'
  | 'six-kind'
  | 'chance';

export interface ComboResult {
  id: ComboId;
  /** Punti base della combo (0 per la Somma secca: lì i chips sono la somma stessa). */
  base: number;
  /** Indici dei dadi che compongono la combo — i loro pips entrano nei chips. */
  usedIndices: number[];
  /** base + somma pips dei dadi usati. */
  chips: number;
}

export interface ScoredHand {
  best: ComboResult;
  /** Tutte le combo rilevate, ordinate per chips decrescenti (per la preview UI). */
  all: ComboResult[];
  chips: number;
  /** Moltiplicatore — fisso a 1 finché non esistono i talismani (Sprint 1). */
  mult: number;
  score: number;
}

export interface HandState {
  faces: number[];
  held: boolean[];
  /** Lanci già effettuati (1 dopo il lancio iniziale). */
  rollsUsed: number;
  closed: boolean;
}
